export const T = {
  en_GB: {
    failedToLoad: "Could not load the accounts.",
    failedToSave: "Failed to save transfer",
    failedToDelete: "Failed to delete transfer",
  },
  nb_NO: {
    failedToLoad: "Kunne ikke laste kontoene.",
    failedToSave: "Kunne ikke lagre overføringen",
    failedToDelete: "Kunne ikke slette overføringen",
  },
} as const;
